import { supabase } from "./client";

export const supabaseRealtimeProvider = {
  /**
   * Suscribe una función callback a cambios en una tabla específica.
   * @param {string} channelName - Nombre único del canal.
   * @param {string} table - Nombre de la tabla de la base de datos.
   * @param {string} event - Evento a escuchar ('*' | 'INSERT' | 'UPDATE' | 'DELETE').
   * @param {function} callback - Función que maneja el payload recibido.
   * @returns {function} Función de desuscripción (limpieza).
   */
  subscribeToTable: (channelName, table, event, callback, filter = undefined) => {
    const channel = supabase
      .channel(channelName)
      .on(
        "postgres_changes",
        { event: event, schema: "public", table: table, filter: filter },
        (payload) => {
          callback(payload);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  },

  /**
   * Crea un canal realtime multinivel que escucha múltiples eventos y tablas agrupados.
   * Útil para el hook global 'useRealtimeSubscriptions'.
   * @param {string} channelName - Nombre único para el canal agrupado.
   * @param {Array<{table: string, event: string, callback: function, filter?: string}>} subscriptions - Arreglo de suscripciones.
   * @returns {function} Función para desuscribir todo el canal.
   */
  subscribeGroup: (channelName, subscriptions) => {
    let channel = supabase.channel(channelName);

    subscriptions.forEach(({ table, event, callback, filter }) => {
      const config = { event: event, schema: "public", table: table };
      if (filter) {
        config.filter = filter;
      }
      channel = channel.on(
        "postgres_changes",
        config,
        (payload) => {
          callback(payload);
        }
      );
    });

    channel.subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  },
};
